import s from './chinese-docks.module.css';

function ChineseDocks() {
    return (
        <div className={s.chineseDocks}>Docks production speed +10%</div>
    )
}

export default ChineseDocks;
